import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/check.png'
import _imports_1 from '../../assets/close.png'


const _hoisted_1 = { class: "route-info-dialog" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "route-info-dialog__header" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "路線資訊")
], -1)
const _hoisted_3 = { class: "route-info-dialog__body" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h5", null, "發車資訊", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h6", null, "頭末班車：", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h6", null, "營運日期：", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "operation-time-list" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "day" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "day__text" }, " 一 "),
    /*#__PURE__*/_createElementVNode("div", { class: "day__check" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_0,
        alt: ""
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "day" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "day__text" }, " 二 "),
    /*#__PURE__*/_createElementVNode("div", { class: "day__check" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_0,
        alt: ""
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "day" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "day__text" }, " 三 "),
    /*#__PURE__*/_createElementVNode("div", { class: "day__check" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_0,
        alt: ""
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "day" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "day__text" }, " 四 "),
    /*#__PURE__*/_createElementVNode("div", { class: "day__check" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_0,
        alt: ""
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "day" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "day__text" }, " 五 "),
    /*#__PURE__*/_createElementVNode("div", { class: "day__check" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_0,
        alt: ""
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "day" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "day__text" }, " 六 "),
    /*#__PURE__*/_createElementVNode("div", { class: "day__check" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_0,
        alt: ""
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "day" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "day__text" }, " 日 "),
    /*#__PURE__*/_createElementVNode("div", { class: "day__check" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_0,
        alt: ""
      })
    ])
  ])
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h5", null, "票價資訊", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h6", null, "收費方式：", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h5", null, "服務客運", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h6", null, "客運業者：", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h6", null, "聯繫電話：", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("section", null, [
        _hoisted_5,
        _createElementVNode("p", null, "平日：" + _toDisplayString(_ctx.busRouteInfo[0]?.SubRoutes[0].FirstBusTime) + "-" + _toDisplayString(_ctx.busRouteInfo[0]?.SubRoutes[0].LastBusTime), 1),
        _createElementVNode("p", null, "假日：" + _toDisplayString(_ctx.busRouteInfo[0]?.SubRoutes[0].HolidayFirstBusTime) + "-" + _toDisplayString(_ctx.busRouteInfo[0]?.SubRoutes[0].HolidayLastBusTime), 1),
        _hoisted_6,
        _hoisted_7
      ]),
      _hoisted_8,
      _createElementVNode("section", null, [
        _hoisted_9,
        _createElementVNode("p", null, _toDisplayString(_ctx.busRouteInfo[0]?.TicketPriceDescriptionZh || '-'), 1)
      ]),
      _hoisted_10,
      _createElementVNode("section", null, [
        _hoisted_11,
        _createElementVNode("p", null, _toDisplayString(_ctx.busOperatorInfo?.OperatorName.Zh_tw), 1),
        _hoisted_12,
        _createElementVNode("p", null, _toDisplayString(_ctx.busOperatorInfo?.OperatorPhone), 1)
      ]),
      _createElementVNode("div", {
        class: "close-button",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
      }, [
        _createElementVNode("img", {
          src: _imports_1,
          alt: "close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        })
      ])
    ])
  ]))
}